import home from './src/home.vue'
import TicketOutandInView from './src/TicketManager/TicketOutandInView.vue' 
import TicketIncomeView from './src/TicketManager/TicketIncomeView.vue'
import TouristsportraitView from './src/TicketManager/TouristsportraitView.vue'
import PassengerFlowDay from './src/ticketStatistics/PassengerFlowDay.vue' 
import PassengerFlowMonth from './src/ticketStatistics/PassengerFlowMonth.vue'
import PassengerFlowYear from './src/ticketStatistics/PassengerFlowYear.vue'
import TourPortrayal from './src/ticketStatistics/TourPortrayal.vue' 
import TicketDayTrend from './src/ticketStatistics/TicketDayTrend.vue'
import TicketMonthTrend from './src/ticketStatistics/TicketMonthTrend.vue'
import TicketYearTrend from './src/ticketStatistics/TicketYearTrend.vue'
import LogOperationTrend from './src/ticketStatistics/LogOperationTrend.vue'
import LogAlarmTrend from './src/ticketStatistics/LogAlarmTrend.vue'
let views = {
    home,
    TicketOutandInView,
    TicketIncomeView,
    TouristsportraitView,
    PassengerFlowDay,
    PassengerFlowMonth,
    PassengerFlowYear,
    TourPortrayal,
    TicketDayTrend,
    TicketMonthTrend,
    TicketYearTrend,
    LogOperationTrend,
    LogAlarmTrend
};

export default views;